// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + "vendors" + "." + "8f168f849d1bd981d12c" + ".bundle.js";
};